import * as React from "react";
import Nav from "@/components/Nav";
import styles from "./styles.module.css";
import Breadcrumb from "@/components/Breadcrumb";
import { Breadcrumb as BreadcrumbType } from "@/types/index";

const Header: React.FC<{
	left: React.ReactNode;
	right: React.ReactNode;
	breadcrumbs?: BreadcrumbType;
	theme?: {
		paddingTop: 0 | 1 | 2 | 3 | 4 | 5;
		paddingRight: 0 | 1 | 2 | 3 | 4 | 5;
		paddingLeft: 0 | 1 | 2 | 3 | 4 | 5;
		paddingBottom: 0 | 1 | 2 | 3 | 4 | 5;
	};
}> = ({
	left,
	right,
	breadcrumbs,
	theme = {
		paddingTop: 5,
		paddingRight: 0,
		paddingLeft: 0,
		paddingBottom: 5,
	},
}) => {
	return (
		<header>
			<Nav />
			<div className={`d-flex flex-fill ${styles.header}`}>
				<div
					className={`container py-5 pt-lg-${theme.paddingTop} ps-lg-${theme.paddingLeft} pe-lg-${theme.paddingRight} pb-lg-${theme.paddingBottom} d-flex flex-column flex-fill`}
				>
					{breadcrumbs && (
						<div className="row">
							<div className="col d-none d-md-block">
								<Breadcrumb items={breadcrumbs} />
							</div>
						</div>
					)}
					<div className={`text-md-start text-center row flex-fill`}>
						<div className="col-12 col-lg d-flex justify-content-center align-items-center">
							{left}
						</div>
						<div className="d-none col-lg d-lg-flex align-items-center justify-content-center">
							{right}
						</div>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
